// ADR-119 amendment 1: Organizational Structure Type codes the UI keys
// behaviour on. Codes are admin-managed data, so the mapping is configuration
// (env) with a default, never a literal at the call site.
//
// REGION: Clusters of this type are what the Individuals Repository
// offers as "Regions" — the cluster an individual is hired in.
export const REGION_STRUCTURE_TYPE_CODE = import.meta.env.VITE_REGION_STRUCTURE_TYPE_CODE || 'R';
